// Local history and favorites management
import localforage from 'localforage';

// Initialize localforage instances
const historyStore = localforage.createInstance({
  name: 'scrawl',
  storeName: 'history'
});

const favoritesStore = localforage.createInstance({
  name: 'scrawl',
  storeName: 'favorites'
});

// History Management
export const addToHistory = async (paste) => {
  try {
    const history = await getHistory();
    const newHistory = [
      { ...paste, savedAt: new Date().toISOString() },
      ...history.filter(p => p.id !== paste.id)
    ].slice(0, 50); // Keep last 50 items
    await historyStore.setItem('pastes', newHistory);
    return newHistory;
  } catch (error) {
    console.error('Error adding to history:', error);
    return [];
  }
};

export const getHistory = async () => {
  try {
    const history = await historyStore.getItem('pastes');
    return history || [];
  } catch (error) {
    return [];
  }
};

export const removeFromHistory = async (id) => {
  try {
    const history = await getHistory();
    const newHistory = history.filter(p => p.id !== id);
    await historyStore.setItem('pastes', newHistory);
    return newHistory;
  } catch (error) {
    console.error('Error removing from history:', error);
    return [];
  }
};

export const clearHistory = async () => {
  try {
    await historyStore.setItem('pastes', []);
    return [];
  } catch (error) {
    console.error('Error clearing history:', error);
    return [];
  }
};

// Favorites Management
export const addToFavorites = async (paste) => {
  try {
    const favorites = await getFavorites();
    if (favorites.some(p => p.id === paste.id)) {
      return favorites; // Already exists
    }
    const newFavorites = [
      { ...paste, favoritedAt: new Date().toISOString() },
      ...favorites
    ];
    await favoritesStore.setItem('pastes', newFavorites);
    return newFavorites;
  } catch (error) {
    console.error('Error adding to favorites:', error);
    return [];
  }
};

export const getFavorites = async () => {
  try {
    const favorites = await favoritesStore.getItem('pastes');
    return favorites || [];
  } catch (error) {
    console.error('Error getting favorites:', error);
    return [];
  }
};

export const removeFromFavorites = async (id) => {
  try {
    const favorites = await getFavorites();
    const newFavorites = favorites.filter(p => p.id !== id);
    await favoritesStore.setItem('pastes', newFavorites);
    return newFavorites;
  } catch (error) {
    console.error('Error removing from favorites:', error);
    return [];
  }
};

export const isFavorite = async (id) => {
  const favorites = await getFavorites();
  return favorites.some(p => p.id === id);
};
